export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/KW-246e255f060624b765f2d1566b5555c4.png";